import { render, staticRenderFns } from "./ModalTurnOnFlame.vue?vue&type=template&id=2d0f0b2c&scoped=true"
import script from "./ModalTurnOnFlame.vue?vue&type=script&lang=js"
export * from "./ModalTurnOnFlame.vue?vue&type=script&lang=js"
import style0 from "./ModalTurnOnFlame.vue?vue&type=style&index=0&id=2d0f0b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f0b2c",
  null
  
)

export default component.exports